<div id="frfooter">
    <div class="content-container">
        <div class="pure-g footer_wrapper">
            <div class="pure-u-1 pure-u-md-12-24 img_sec">
                <a class="csllogo" routerLink="/fr/home" title="CSLB logo">
                    <img src="/assets/img/CSLB_logo.svg" alt="CSLB logo" class="" />
                </a>
            </div>
            <div class="pure-u-1 pure-u-md-12-24 footer_menu">
                <ul>
                    <li><a target="_blank" href="https://www.csl.com/privacy-policy" title="Politique de confidentialité">Politique de confidentialité</a></li>
                    <li><a target="_blank" href="https://www.cslbehring.ca/fr-fr/conditions-d-utilisation" title="Modalités d’utilisation">Modalités d’utilisation</a></li>
                    <li><a target="_blank" href="https://www.cslbehring.ca/fr-fr/sitemap" title="Plan du site">Plan du site</a></li>
                </ul>
            </div>
        </div>
        <div class="horizontal_bor"></div>
        <div class="pure-g trade_sec">
            <div class="pure-u-1">
                <p>&copy;{{currentYear}} CSL Behring. Tous droits réservés.</p>
                <p>Hizentra<sup>&reg;</sup> est fabriqué par CSL Behring AG et distribué par CSL Behring Canada Inc.
                </p>
                <p>HAEGARDA<sup>&reg;</sup> est une marque déposée de CSL Behring GmbH, fabriquée par CSL Behring AG et distribuée par CSL Behring Canada Inc.
                </p>                
                <p>Berinert<sup>&reg;</sup> est une marque déposée de CSL Behring GmbH. </p>
                <p>Humate-P<sup>&reg;</sup> est une marque déposée de CSL Behring GmbH.</p>
            </div>
        </div>
    </div>
</div>